/**
* @desc: 对公转账弹窗提醒
* @author: zengtiansheng
* @update: 2018/3/17
*/
<style lang="less" scoped>
.dialog-title {
  margin-left: 20px;
  color: #9c9c9c;
  font-size: 12px;
}
.dialog-content {
  margin-left: 20px;
  .part-img {
    width: 60px;
    height: 60px;
    margin-right: 20px;
    border-radius: 30px;
  }
  .detail {
    color: #3c3c3c;
    font-size: 12px;
    p {
      margin-bottom: 4px;
    }
  }
}
</style>
<template>
  <el-dialog :visible.sync="dialogVisible" width="520px">
    <div slot="title" class="dialog-title">
      <p>若您需要进行充值，转账成功后请联系我们商务经理</p>
      <p style="color:#F85359;">转账请务必备注付款公司名称</p>
    </div>
    <div class="dialog-content f-js-as">
      <img class="part-img" src="https://qiniu-image.qtshe.com/logo_bak.png-100" alt="part-img" />
      <div class="detail">
        <p>
          <span style="margin-right: 40px">商务经理：陈欣</span>
          <span>电话：18815294089</span>
        </p>
        <p>收款公司：{{accountName}}</p>
        <p>收款账户：{{accountNo}}</p>
      </div>
    </div>
    <span slot="footer">
      <el-button type="primary" @click="dialogVisible=false">我知道了</el-button>
    </span>
  </el-dialog>
</template>
<script>
export default {
  data() {
    return {
      accountNo: '',
      accountName: '',
      dialogVisible: true
    }
  },
  methods: {
    async getRechargeData() {
      try {
        const res = await this.$axios('/qtbForeignPayCenter/pc/company/order/transfer/account')
        if (res.success) {
          this.accountNo = res.data.accountNo
          this.accountName = res.data.name
        }
      } catch (error) {
        this.$message({type: 'error', message: '网络错误，请稍后重试'})        
      }
    }
  },
  mounted() {
    this.getRechargeData()
  }
}
</script>



// WEBPACK FOOTER //
// src/components/dialog/qtbaoApiTransferAccRemind.vue